import $ from "jquery/dist/jquery";

$(() => {
  function showHideInvoiceForm() {
    if ($("#id_invoice_same_as_delivery").is(":checked")) {
      $("#invoice").hide();
    } else {
      $("#invoice").show();
    }
  }

  $("#id_invoice_same_as_delivery").change(showHideInvoiceForm);
  showHideInvoiceForm();
});
